<p-fileUpload
  #fileUpload
  name="documents[]"
  [customUpload]="true"
  [multiple]="true"
  [accept]="acceptTypes"
  [maxFileSize]="1000000000"
  [showUploadButton]="false"
  [showCancelButton]="false"
  styleClass="hidden"
  (onSelect)="onFileSelect(); openDialog()"
  (clear)="onClearSelection()"
/>

<p-button
  icon="pi pi-upload"
  [label]="'animalDocuments.upload.button' | transloco"
  (click)="fileUpload.choose()"
/>

<p-dialog
  [header]="'animalDocuments.upload.dialogHeader' | transloco"
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: '60vw' }"
  [closable]="true"
  [dismissableMask]="true"
  appendTo="body"
  (onHide)="onDialogHide()"
>
  <div *ngFor="let file of selectedFiles; let i = index" class="p-4">
    <div class="grid grid-cols-[220px_1fr_1fr_30px] gap-4 items-center">
      <div class="flex flex-col items-center gap-2 text-center">
        <i class="{{ fileMeta(file).icon }} text-5xl {{ fileMeta(file).colorClass }}"></i>
        <span class="text-xs text-gray-600 break-all">{{ file.file.name }}</span>
        <span class="text-xs text-gray-400">{{ (file.file.size / 1048576) | number:'1.2-2' }} MB</span>
      </div>

      <div class="flex flex-col">
        <label class="text-sm font-semibold text-gray-600 mb-1">
          <i class="pi pi-tag mr-2"></i>{{ 'animalDocuments.labels.category' | transloco }}
        </label>
        <p-select
          [options]="categoryOptions"
          [(ngModel)]="file.category"
          optionLabel="name"
          optionValue="value"
          appendTo="body"
          styleClass="w-full"
        />
      </div>

      <div class="flex flex-col">
        <label class="text-sm font-semibold text-gray-600 mb-1">
          <i class="pi pi-calendar mr-2"></i>{{ 'animalDocuments.labels.date' | transloco }}
        </label>
        <p-datepicker
          [(ngModel)]="file.uiDate"
          [showIcon]="true"
          iconDisplay="input"
          dateFormat="dd.mm.yy"
          appendTo="body"
          styleClass="w-full"
        />
      </div>

      <div class="flex flex-col">
        <p-button
          (click)="removeFile(i)"
          icon="pi pi-trash"
          [rounded]="true"
          severity="danger"
        />
      </div>
    </div>

    @if (selectedFiles.length > 1 && i < selectedFiles.length - 1) {
      <p-divider></p-divider>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-upload"
      [label]="'animalDocuments.upload.submit' | transloco"
      (click)="uploadFiles()"
      [disabled]="!selectedFiles.length"
    />
  </ng-template>
</p-dialog>
